export default __webpack_public_path__ + "static/combination-of-different-series-types-675ef1775667450fcc91e715b2663b68.png";